import { render } from "./AppraisalSalesman.vue?vue&type=template&id=597d44a3&scoped=true"
import script from "./AppraisalSalesman.vue?vue&type=script&lang=js"
export * from "./AppraisalSalesman.vue?vue&type=script&lang=js"

import "./AppraisalSalesman.vue?vue&type=style&index=0&id=597d44a3&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597d44a3"]])

export default __exports__